module.exports = __webpack_public_path__ + "img/natsur.22cc7024.png";